import { Box, Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import TableView from "../TableView";

export default function InfoStep03() {

  const { getValues } = useFormContext()
  const { step03 } = getValues()

  return (
    <Box display={'flex'} rowGap={1} columnGap={4} flexWrap={'wrap'}>
      <TableView
        title="Local de cobrança"
        text={`${step03.local_cobranca.nome}`}
      />

      <TableView
        title="Histórico"
        text={`${step03.historico.id} - ${step03.historico.nome}`}
      />
      
      <TableView
        title="Departamento"
        text={`${step03.departamento.id} - ${step03.departamento.nome}`}
      />  

      <Box mb={1}>
        <Typography variant="subtitle2" color="textSecondary">
          Conta devedora
        </Typography>

        <Stack direction={'column'}>
          <Typography variant="subtitle1" color="textSecondary">
            {`${step03.conta_devedora.codigo_contabil} - ${step03.conta_devedora.nome}`}
          </Typography>
          {
            step03.conta_devedora.centro_custo &&
            <Typography variant="subtitle1" color="textSecondary">
              {`Centro de custo: ${step03.conta_devedora.centro_custo.id} -${step03.conta_devedora.centro_custo.nome}`}
            </Typography>
          }
        </Stack>
      </Box>

      <Box mb={1}>
        <Typography variant="subtitle2" color="textSecondary">
          Conta credora
        </Typography>

        <Stack direction={'column'}>
          <Typography variant="subtitle1" color="textSecondary">
            {`${step03.conta_credora.codigo_contabil} - ${step03.conta_credora.nome}`}
          </Typography>

          {
            step03.conta_credora.centro_custo &&
            <Typography variant="subtitle1" color="textSecondary">
              {`Centro de custo: ${step03.conta_credora.centro_custo.id} - ${step03.conta_credora.centro_custo.nome}`}
            </Typography>
          }
        </Stack>
      </Box>

      <TableView
        title="Observação"
        text={`${step03.observacao || "-"}`}
      />
    </Box>
  )
}
